let $ = require("jquery");
import _ from "underscore";
import render from '../../utilities/render';
import {isFalsey, isBlank} from '../../utilities/general'
import {setElementsFromScope} from '../../utilities/selectorHelpers';
import {quickFileUploader} from "../../components/QuickFileUploader/QuickFileUploader";
const modalHtml = require("../../sharedHtml/modal.html");
import SubmitModalFlow from "../../components/SubmitModalFlow/SubmitModalFlow";
import {SUCCESS_MODAL_TIMEOUT_WITH_REDIRECT, MAX_FILE_SIZE} from "../../constants";

export default function bulkUploadCsvFiles(targetSelector){

  const outerEl = $(targetSelector);
  const bulkUploadCsvForm = outerEl.find("#bulk-upload-csv-form");
  const uploadFileButton = outerEl.find(".upload-file");
  const selectFileButton = outerEl.find(".select-file-btn");
  const csvFileUpload = outerEl.find(".file-uploader");
  const uploadFileUrl = outerEl.data("upload-csv-url");
  const viewBulkUploadDetailUrl = outerEl.data("bulk-upload-details-url");
  const serviceCenterHelpUrl = outerEl.data("service-center-url");
  const bulkUploadId = outerEl.find("#bulk-upload-id");
  const submitModalFlow = new SubmitModalFlow();
	submitModalFlow.init();

  const quickFile = quickFileUploader(csvFileUpload,{
    afterReadFile: function(e,result){
      uploadFileButton.removeClass("disabled");
    }
  });

  const csvUploadSuccessModal = $(render(
    modalHtml,
    {
      title: ' About Your Upload',
      leftAlignTitle: true,
      body: '<div class="q-pad-all-xl">  Your bulk upload has been submitted. Go to the detail summary for this upload where you will be able to view its statuses and manage error files that may occur. You may also close this modal to upload additional files. </div>',
      topCloseBtn: true,
      autoHideTop: true,
      footerBtns: `
        <a href="#" class="base-btn v2-btn purple-btn modal-auto-hide">Close</a>
        <a href="#" class="base-btn purple-btn custom-submit-btn bulk-upload-details">Go to Details</a>
      `
    }
  ));

  const fileFormatErrorModal = $(render(
    modalHtml,
    {
      title: 'File Format Error',
      leftAlignTitle: true,
      body: '<div class="q-pad-all-xl"> The file you have uploaded is an invalid file format and only .CSV files are currently accepted. You may download the approved CSV template above.</div>',
      topCloseBtn: true,
      autoHideTop: true,
      footerBtns: `
        <a href="#" class="base-btn purple-btn modal-auto-hide">Close</a>
      `
    }
  ));

  const fileSizeErrorModal = $(render(
    modalHtml, {
      title: 'File Size Error',
      leftAlignTitle: true,
      body: '<div class="q-pad-all-xl">The file selected exceeds the required file size. Please limit your file to be no larger than 5 MB and try uploading again.</div>',
      topCloseBtn: true,
      autoHideTop: true,
      footerBtns: `
        <a href="#" class="base-btn purple-btn modal-auto-hide">Close</a>
      `
    }
  ));


  const duplicateFileErrorModal = $(render(
    modalHtml,
    {
      title: 'Duplicate File Warning',
      leftAlignTitle: true,
      body: '<div class="q-pad-all-xl"> A file with the same name has been previously uploaded. Please check that this is not in error as you may be creating duplicate entries within in your system.</div>',
      topCloseBtn: true,
      autoHideTop: true,
      footerBtns: `
        <a href="#" class="base-btn purple-btn custom-submit-btn continue-upload">Continue Upload</a>
        <a href="#" class="base-btn purple-btn purple-btn modal-auto-hide">Cancel Upload</a>
      `
    }
  ));

  uploadFileButton.on('click',function(e){
      const fileName = quickFile.getFile().name;
      const file = $("#info-img-hidden")[0].files[0];
      let formData = new FormData();
      formData.append("fileName", file);
      const fileExtension = fileName.split('.').pop().toLowerCase();
      if(fileExtension != 'csv'){
        fileFormatErrorModal.modal("show");
      }else if(file.size > MAX_FILE_SIZE){
        fileSizeErrorModal.modal("show");
      }else{
        $.ajax({
            url: uploadFileUrl,
            type: 'POST',
            data: formData,
            enctype:"multipart/form-data",
            processData:false,
            contentType:false,
            dataType: "json",
            success: function (resp) {
                if (resp.data && resp.data != null && resp.data != 'null'){
                  if(resp.data == 'Y'){
                    duplicateFileErrorModal.modal("show");
                  }else{
                    bulkUploadId.val(resp.data);
                    csvUploadSuccessModal.modal("show");
                  }
              }
            },
            error: function (xhr, status, error) {
              submitModalFlow.showFailureModal();
            }
        });
    }

  });

  $(document).on("click", '.continue-upload', function(e) {
    const fileName = quickFile.getFile();
    let formData = new FormData();
    formData.append("fileName",$("#info-img-hidden")[0].files[0]);
      $.ajax({
          url: `${uploadFileUrl}&duplicateFile=Y`,
          type: 'POST',
          data: formData,
          enctype:"multipart/form-data",
          processData:false,
          contentType:false,
          dataType: 'json',
          success: function (resp) {
              if (resp.data && resp.data != null && resp.data != 'null') {
                 bulkUploadId.val(resp.data);
                 csvUploadSuccessModal.modal("show");
                 duplicateFileErrorModal.modal("hide");
              }
          },
          error: function (xhr, status, error) {
            submitModalFlow.showFailureModal();
          }
      });
  });

  $(document).on("click", '.bulk-upload-details', function(e) {
    let bupUuid = bulkUploadId.val();
    location.href = `${viewBulkUploadDetailUrl}&bupId=${bupUuid}`;
  });

  $(document).on("click",'#redirectInstructionspage',function (e) {
    window.open(serviceCenterHelpUrl);
  });

}



// WEBPACK FOOTER //
// ./src/pages/bulkUpload/bulkLoadUpload.js